import {
  Form, FormActionsAlign, FormHandlers, Icon,
} from '@doveit/bricks';
import React from 'react';
import { ThemeIcons } from '../../../theme/icons';
import { updateApplicantValidationSchema } from './UpdateApplicantForm.schema';

export interface UpdateApplicantFormModel {
  name: string,
  phoneNumber: string,
  email: string,
  linkedIn: string,
}

export interface UpdateApplicantFormProps extends React.AriaAttributes {
  initialValues?: Partial<UpdateApplicantFormModel>,
  loading?: boolean,
  disabled?: boolean,
  innerRef?: React.MutableRefObject<FormHandlers>,
  onSubmit: (values: UpdateApplicantFormModel) => void,
}

const DEFAULT_INITIAL_VALUES: UpdateApplicantFormModel = {
  name: '',
  phoneNumber: '',
  email: '',
  linkedIn: '',
};

const UpdateApplicantForm: React.FC<UpdateApplicantFormProps> = ({
  initialValues,
  loading = false,
  disabled = false,
  innerRef,
  onSubmit,
  ...rest
}) => {
  const mergedInitialValues = React.useMemo(() => ({
    ...DEFAULT_INITIAL_VALUES,
    ...initialValues,
  }), [initialValues]);

  return (
    <Form
      initialValues={mergedInitialValues}
      validationSchema={updateApplicantValidationSchema}
      loading={loading}
      disabled={disabled}
      innerRef={innerRef}
      onSubmit={onSubmit}
      {...rest}
    >
      <Form.Item>
        <Form.Input
          name="name"
          label="Nome e cognome"
          placeholder="Es. Mario Rossi"
          aria-label="Campo per inserire il nome e il cognome"
          type="text"
          required
        />
      </Form.Item>

      <Form.Item size={{ MD: 1 / 2 }}>
        <Form.Input
          name="email"
          label="Email"
          placeholder="Es. mario.rossi@gmail.com"
          aria-label="Campo per inserire l'indirizzo email"
          type="text"
        />
      </Form.Item>

      <Form.Item size={{ MD: 1 / 2 }}>
        <Form.Input
          name="phoneNumber"
          label="Numero di telefono"
          placeholder="Es. 3923456789"
          aria-label="Campo per inserire il numero di telefono"
          type="text"
        />
      </Form.Item>

      <Form.Item>
        <Form.Input
          name="linkedIn"
          label="Profilo LinkedIn"
          placeholder="Es. https://www.linkedin.com/in/mariorossi"
          prefixElement={<Icon path={ThemeIcons.LINKEDIN} />}
          aria-label="Campo per inserire il profilo LinkedIn"
          type="text"
        />
      </Form.Item>

      {!innerRef && (
        <Form.Actions align={FormActionsAlign.RIGHT}>
          <Form.Submit label="Salva" />
        </Form.Actions>
      )}
    </Form>
  );
};

export default UpdateApplicantForm;
